<template>
  <div class="clearfix">
    <!-- 왼쪽 -->
    <div
      :id="`${getActivityAreaId(leftSide)}-normal`"
      class="floL"
      :class="{ marTML: rowIdx > 0 }"
    >
      <p class="fntH6 fntL bold padBSM" style="color:#2c2c2c;">{{ leftSide.name }}님의 <em class="regular">{{ title }}</em></p>
      <div class="amway-theme">
        <div class="radio-wrapper pf23-active-radio pf23-radioBtn">
          <!-- 일반 액티비티 영역 -->
          <SurveyReturnScheduleExample
            v-for="example in normalExamples"
            :key="`row${rowIdx}_left_${example.se_code}`"
            :examples="normalExamples"
            :example="example"
            :attendant="leftSide"
            :unique="`${sqCode}_row${rowIdx}_left`"
          />
          <!-- vip 액티비티가 노출되는 경우 일반 액티비티에 "선택 안함" 선택지 노출 => 모든 경우에 선택 안함 추가 -->
          <SurveyReturnScheduleExample
            :examples="normalExamples"
            :example="noneExample"
            :attendant="leftSide"
            :unique="`${sqCode}_row${rowIdx}_left`"
            v-if="noneSelect"
          />
        </div>
      </div>

    </div>
    <template v-if="rightSide">
      <!-- <hr class="moOnly" style="border-top:1px solid #e3e3e3;" />-->
      <!-- 오른쪽 -->
      <div
        :id="`${getActivityAreaId(rightSide)}-normal`"
        class="floR"
        :class="{ marTML: rowIdx > 0 }"
      >
        <p class="fntH6 fntL bold padBSM" style="color:#2c2c2c;">{{ rightSide.name || '배우자' }}님의 {{title}}</p>
        <div class="amway-theme">
          <div class="radio-wrapper pf23-active-radio pf23-radioBtn">
            <!-- 일반 액티비티 영역 -->
            <SurveyReturnScheduleExample
              v-for="example in normalExamples"
              :key="`row${rowIdx}_right_${example.se_code}`"
              :examples="normalExamples"
              :example="example"
              :attendant="rightSide"
              :unique="`${sqCode}_row${rowIdx}_right`"
            />
            
          </div>
        </div>

      </div>
      <hr v-if="showBottomHr" class="moOnly" style="border-top:1px solid #e3e3e3;" />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SYDNEY } from '@/store/actions/survey'
import { CommonMethodMixin } from '../mixins'
import SurveyReturnScheduleExample from './SurveyReturnScheduleExample.vue'

export default {
  name: 'SurveyReturnSchedulePair',
  mixins: [CommonMethodMixin],
  components: {
    SurveyReturnScheduleExample,
  },
  props: {
    rowIdx: {
      type: Number,
      required: true
    },
    leftSide: {
      type: Object,
      required: true
    },
    rightSide: {
      type: Object,
      default: null
    },
    activity: {
      type: Object,
      required: true
    },
    showBottomHr: {
      type: Boolean,
      default: false,
    },
    noneSelect: {
      type: Boolean, 
      defualt: false,
    }
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      pinLevel: state => state.pin_level
    }),
    ...mapGetters(SURVEY_SYDNEY, {
    }),
    sqCode() {
      return this.activity.sq_code;
    },
    // 액티비티 문항
    examples() {
      return Object.keys(this.activity.examples).map(se_code => this.activity.examples[se_code]);
    },
    // 항목 제목 
    title() {
       return this.activity.title || '';
    },
    // 액티비티 일반 문항
    normalExamples() {
      return this.examples.filter(example => !example.pin);
    },
    noneExample() {
      return {
        sq_code: this.sqCode,
        se_code: '',
        display_text: '선택안함',
        value: '선택안함',
        remain_num: null,
        pin: null
      };
    }
  },
  methods: {
    getActivityAreaId(attendant) {
      const uniqueType = attendant.type + (attendant.type_seq || '');
      return `${this.sqCode}-${uniqueType}`
    },
  },
}
</script>

<style scoped>
/* 모바일 화면에서 marTML으로 인해 빈 공간 생기는 현상 수정 */
@media screen and (max-width:639px) {
  .clearfix .floL.marTML, .clearfix .floR.marTML {
    margin-top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyReturnSchedulePair.vue